/* eslint-disable import/extensions */
import moduleProjects from './projects';
import moduleCompanies from './companies';
import moduleAccountUser from './account-user';
import moduleProjectUsers from './project-users';
import moduleBusinessUnits from './business-units';
import moduleProjectRoles from './project-roles';

export default {
  namespaced: true,
  modules: {
    projects: moduleProjects,
    companies: moduleCompanies,
    accountUser: moduleAccountUser,
    projectUsers: moduleProjectUsers,
    businessUnits: moduleBusinessUnits,
    projectRoles: moduleProjectRoles,
  },
};
